const LS_KEY_PREFIX = 'AppFrame';
export const LS_KEY_COOKIE_ACCEPTED_IDS = `${LS_KEY_PREFIX}::CookieAcceptedIds`;
export const LS_KEY_LANGUAGE = `${LS_KEY_PREFIX}::Language`;
export const LS_KEY_DARKMODE = `${LS_KEY_PREFIX}::DarkMode`;
export const LS_KEY_AUTO_IGNORE_MODULE_LOAD_ERRORS = `${LS_KEY_PREFIX}::AutoIgnoreModuleLoadErrors`;
export const LS_KEY_ENV_INDICATOR_PINNED = `${LS_KEY_PREFIX}::EnvIndicatorPinned`;

export const LS_KEY_TIMEZONE = `${LS_KEY_PREFIX}::Timezone`;
export const SIDEBAR_ITEM_ORDER_NAMESPACE = {
  appInstance: 'AppFrame',
  appPart: 'Sidebar',
  name: 'ItemOrder',
};
